import StandardRestError from './Standard'

class InvitationNotFoundError extends StandardRestError {
  static CODE = 'INVITATION_NOT_FOUND'

  constructor(
    message: string = 'Invitation not found',
    status = 404,
    body = {},
  ) {
    super(message)
    this.status = status
    this.body = body
  }
}

export default InvitationNotFoundError
